import type {ReactNode} from 'react'

import type {TestOccurrence} from '../../../../services/rest'
import type {BuildId, BuildTypeId, ProjectId, TestId, TestOccurrenceId} from '../../../../types'

export type Filter = {
  agents: ReadonlyArray<{
    label: string
    key: string
  }>
  showFailed: boolean
  showPersonalBuilds: boolean
}
export enum DataTypes {
  DEFAULT = 'DEFAULT',
  AVERAGE = 'AVERAGE',
}
export type Data =
  | {
      type: DataTypes.DEFAULT
      x: number
      y: number
      status: TestOccurrence['status']
      date: string | null | undefined
      color: string
      buildId: BuildId | null | undefined
      testOccurrenceId: TestOccurrenceId | null | undefined
    }
  | {
      type: DataTypes.AVERAGE
      x: number
      y: number
      date: string
      color: string
      countBuilds: number
    }
type CommonProps = {
  seqKey?: string
  className?: string
  testId: TestId
  projectId: ProjectId
  buildTypeId?: BuildTypeId | null | undefined
  expandable?: boolean
}
export type ContainerProps = CommonProps & {
  width: number
}
export type PopupContainerProps = CommonProps & {
  anchor: ReactNode
}
export type Props = CommonProps & {
  width: number
  testOccurrences: ReadonlyArray<TestOccurrence>
}
